import { useState, useEffect, useRef  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';
import Konva from 'konva';



import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';

const getTextWidth = (text, font) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text).width;
}


const SpinningWheelOffersReport = (props) => {
  const canvasRefs = useRef([]);
  if (canvasRefs.current.length !== 100) {
    canvasRefs.current = Array.from({ length: 100 }, (_, i) => canvasRefs.current[i] || { current: null });
  }


  useEffect(() => {
    if (props.wheelSettings && props.wheelSettings.slices) {
      const numSlices = props.wheelSettings.slices.length
      
      //console.log(canvasRefs.current)
      for (let i=0; i<numSlices; i+=1) renderSlice(i)
      
    }
  }, [props.wheelSettings])



  const degToRad = (deg) => {
    return deg * Math.PI / 180;
  }
  
  const renderSlice = (sliceIndex) => {
    
    const wheelSettings = props.wheelSettings;

    const sliceAngle = (360 / wheelSettings.slices.length)
    const sliceAngleRad = degToRad(sliceAngle)
    const wedgeWidth = Math.sqrt(2 * wheelSettings.radius * wheelSettings.radius -2*wheelSettings.radius*wheelSettings.radius*Math.cos(sliceAngleRad))
    //console.log(wedgeWidth)
    const wheel = new Konva.Group({ id: "wheelGroup", x: wedgeWidth / 2 +5, y: wheelSettings.radius +5});

    const stage = new Konva.Stage({
        container: `slice${sliceIndex}`,
    });

    const canvasRef = canvasRefs.current[sliceIndex].current 

    canvasRef.current = stage;


    canvasRef.current.width(wedgeWidth + 10);
    canvasRef.current.height(wheelSettings.radius +10);
    canvasRef.current.container().style.width = `${wedgeWidth + 10}px`;
    canvasRef.current.container().style.height = `${wheelSettings.radius + 10}px`;

    

    const layer = new Konva.Layer();

    layer.add(wheel);
    stage.add(layer);

    const wedge = new Konva.Wedge({
      x: 0,
      y: 0,
      radius: wheelSettings.radius,
      angle: sliceAngle,
      fill: wheelSettings.slices[sliceIndex].color,
      rotation: -90 - sliceAngle / 2,
      stroke: wheelSettings.sliceStrokeColor,
      strokeWidth: wheelSettings.sliceStrokeWidth,
  });
  wheel.add(wedge);


  let finalHeight = renderText(wheelSettings.textStartHeight, sliceIndex, wheelSettings.slices[sliceIndex])
  finalHeight -= wheelSettings.slices[sliceIndex].heightBetweenTitleAndSubtitle;
  let iconStartHeight = finalHeight
  finalHeight = renderText(finalHeight, sliceIndex, wheelSettings.slices[sliceIndex], true)
  if (wheelSettings.slices[sliceIndex].subtitle.length > 0) iconStartHeight = finalHeight;


  if (wheelSettings.slices[sliceIndex].addIcon) {
    const imageObj = new Image();
    imageObj.src = wheelSettings.slices[sliceIndex].icon.b64;

    imageObj.onload = function () {
      const konvaImage = new Konva.Image({
        x: -imageObj.width/2,
        y: -iconStartHeight,
        image: imageObj,
        width: imageObj.width,
        height: imageObj.height,
      });

      wheel.add(konvaImage);

      layer.draw();
    };
  }


  }

  const renderText = (startHeight, sliceIndex, slice, renderSubtitle) => {
    const wheelSettings = props.wheelSettings;

    let words = slice.text.split(' ');
    if (renderSubtitle) words = slice.subtitle.split(' ')

    let lines = [];
    let numLinesUsed = 0;
    let currentLine = '';
    const safetyWidthConstraint = 20;
  
    const sliceAngle = (360 / wheelSettings.slices.length)
  
    //console.log(startHeight)
    let widthAtCurrentHeight = startHeight / Math.cos(degToRad(sliceAngle/2))
    
    //console.log(widthAtCurrentHeight)
    currentLine = words[0]
    let currentLineMinusOneWord = ''
    let previousTextWidth = 0;
    for (let i = 1; i < words.length; i++) {
      let textWidth = 0;
      if (renderSubtitle) textWidth = getTextWidth(currentLine, `${slice.subtitleFSize}px ${slice.subtitleFName}`);
      else textWidth = getTextWidth(currentLine, `${slice.fSize}px ${slice.fName}`);
        //console.log(currentLine)
      //console.log(textWidth)
      if (textWidth >= widthAtCurrentHeight - safetyWidthConstraint) {
        lines.push({txt: currentLineMinusOneWord, txtLength: previousTextWidth, availableWidth: widthAtCurrentHeight})
        currentLine = words[i-1]
        currentLineMinusOneWord = ''
        previousTextWidth = 0
        numLinesUsed += 1
        if (numLinesUsed >= 3) break;
        widthAtCurrentHeight = (startHeight - slice.fSize) / Math.cos(degToRad(sliceAngle/2))
        if (renderSubtitle) widthAtCurrentHeight = (startHeight - slice.subtitleFSize) / Math.cos(degToRad(sliceAngle/2))
          //console.log(widthAtCurrentHeight)
      }
      currentLineMinusOneWord = currentLine
      previousTextWidth = textWidth;
      currentLine += ' ' + words[i];
    }
    if (currentLine.length > 0) {
      if (renderSubtitle) lines.push({txt: currentLine, availableWidth: widthAtCurrentHeight, txtLength: getTextWidth(currentLine, `${slice.subtitleFSize}px ${slice.subtitleFName}`)})
      else lines.push({txt: currentLine, availableWidth: widthAtCurrentHeight, txtLength: getTextWidth(currentLine, `${slice.fSize}px ${slice.fName}`)})
    }
      const canvasRef = canvasRefs.current[sliceIndex].current 
      const wheel = canvasRef.current.find('#wheelGroup')[0]
      //const layer = canvasRef.getLayers()[0]
  
      //console.log(lines)
    //for each line we draw a konva text
    for (const l of lines) {l.txt = l.txt.trim()}
  
    let finalHeight = 0;
    for (let i=0; i<lines.length; i+=1) {
      const text = new Konva.Text({
        x: -(lines[i].availableWidth)/2 +(lines[i].availableWidth - lines[i].txtLength) / 2 - 6,
        y: renderSubtitle ? -startHeight + slice.subtitleFSize * i : -startHeight + slice.fSize * i,
        text: lines[i].txt,
        fontSize: renderSubtitle ? slice.subtitleFSize : slice.fSize,
        fontFamily: renderSubtitle ? slice.subtitleFName : slice.fName,
        fill: renderSubtitle ? slice.subtitleColor : slice.textColor,
        rotation: 0,
      });
      finalHeight = text.attrs.y

      wheel.add(text)

      //wheel.add(text)
      //rotateTextInGroupAroundPoint(text, sliceAngle * sliceIndex, wheelSettings.canvasWidth / 2, wheelSettings.canvasHeight / 2)
      //console.log(text.attrs)
    }
    return (finalHeight + slice.fSize) * -1 //we need to change the sign 

  
  /*
    var redLine = new Konva.Line({
      points: [-widthAtCurrentHeight/2, -startHeight, widthAtCurrentHeight/2, -startHeight],
      stroke: 'red',
      strokeWidth: 4,
      lineCap: 'round',
      lineJoin: 'round',
    });
  */
  
  
  
  
  }

  const getTotalsForSlice = (index, opensOrClicks) => {
    if (props.data === undefined) return 0

    const defaultSliceIndex = props.wheelSettings.slices.findIndex(s => s.isDefault === true)
    let opens = 0
    let clicks = 0
    const match = props.data.find(d => d.sliceId === index.toString())
    if (match === undefined) return 0; //it's a slice with the  notUsed flag = true (or we have no data yet)
 
    opens = match.totalOpens
    clicks = match.totalClicks

    // we can have opens/clicks for a sliceId = null
    // this happens if we can't detect the slice. these data go to the default slice
    if (index === defaultSliceIndex) {
      const matchDefault = props.data.find(d => d.sliceId === 'null')
      if (matchDefault) {
        console.log(matchDefault)
        opens += matchDefault.totalOpens
        clicks += matchDefault.totalClicks
      }
    }

    return opensOrClicks === 'opens' ? opens : clicks
  }
  
  return <div className='flex flex-col gap-y-4'>
    {props.wheelSettings && props.wheelSettings.slices && <>
      {props.wheelSettings.slices.map((slice, index) => <div className='flex flex-row gap-x-6 items-center'>
      <div id={`slice${index}`} ref={canvasRefs.current[index] }></div>
        <div className='flex flex-col text-ccColorDarkTeal font-poppins'>
          <div className=''>Offer views</div>
          <div className='font-bold text-2xl'>{getTotalsForSlice(index, 'opens')}</div>
        </div>
        <div className='ml-12 flex flex-col text-ccColorDarkTeal font-poppins'>
          <div className=''>Offer clicks</div>
          <div className='font-bold text-2xl'>{getTotalsForSlice(index, 'clicks')}</div>
        </div>
      </div>)
      }
    
    </>
    }
    
    {props.wheelSettings && props.wheelSettings.expiry && props.wheelSettings.expiry.expirySettingsActive && <div>
      <div className='mt-6 mb-2 text-xl text-ccColorDarkTeal font-semibold'>After Expiry</div>

      <div className='flex flex-row gap-x-6 items-center'>
        <div className='bg-slate-200 rounded p-4 mt-2 w-[330px] h-[280px] flex justify-center items-center'>
        <div className='relative' >

            <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${props.wheelSettings.expiry.imageB64}`} />


          </div>
        </div>

        <div className='flex flex-col text-ccColorDarkTeal font-poppins'>
          <div className=''>Offer views</div>
          <div className='font-bold text-2xl'>{getTotalsForSlice('expired href', 'opens')}</div>
        </div>
        <div className='ml-12 flex flex-col text-ccColorDarkTeal font-poppins'>
          <div className=''>Offer clicks</div>
          <div className='font-bold text-2xl'>{getTotalsForSlice('expired href', 'clicks')}</div>
        </div>

      </div>

    </div>
    }

  </div>
}


export default function SnippetSpinningWheelReport() {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [snippetWebPageStats, setSnippetWebPageStats] = useState(undefined)
    const [wheelSettings, setWheelSettings] = useState({})
    const [totalOpens, setTotalOpens] = useState(undefined)
    const [totalClicks, setTotalClicks] = useState(undefined)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetWebPageStats(undefined)
        setSnippetInfo(undefined)
        setTotalOpens(undefined)
        setTotalClicks(undefined)
        getSpinningWheelStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSpinningWheelStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/spinningwheel/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetWebPageStats(data)
      const [tOpens, tClicks] = getTotals(data)
      setTotalOpens(tOpens)
      setTotalClicks(tClicks)

    } catch (error) {
      //console.log(error);
    }
  }

  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      setSnippetInfo(data)

      const snippetSettings = JSON.parse(data.snippetSettings)
      //console.log(snippetSettings.wheelSettings)
      setWheelSettings(snippetSettings.wheelSettings)
  


    } catch (error) {
      //console.log(error);
    }
  }

  const getNumActiveOffers = () => {
    if (wheelSettings.slices === undefined) return 0;
    const activeSlices = wheelSettings.slices.filter(s => s.notUsed === false)
    return activeSlices.length

  }
  const getTotals = (slices) => {
    let totalOpens = 0;
    let totalClicks = 0;

    slices.forEach(s => {
      totalOpens += s.totalOpens
      totalClicks += s.totalClicks
    })
    return [totalOpens, totalClicks]

  }

    return <div>
            <CcTitle>Element Report Spinning Wheel</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Image Views', value: totalOpens },
                                    {title: 'Clicks', value: totalClicks},
                                    {title: 'Number of offers', value: getNumActiveOffers()},
                                    ]} />
            </div>
            <div className='mt-6 mb-2 text-xl text-ccColorDarkTeal font-semibold'>Clicks per Offer</div>
            <SpinningWheelOffersReport
                    wheelSettings={wheelSettings}
                    data={snippetWebPageStats}
                    //onChange={handleWheelSettingsChange}
                    //validationErrorsList={activeErrorList}
              />
    </div>
}